import React, { useEffect, useState } from "react";
import styles from "../onboard.module.css";
import { Row, Card, Col, Button, Spinner, Modal } from "react-bootstrap";
import { saveBankDetail } from "../../../api";
import { useMyContext } from "../../../myContext";
import addicon from "../../signup/assets/addFundsGrey.svg";
import { fetchRemitterBankDetail, getBankList } from "../../../api";
import CardDetail from "../../../common/CardDetails/CardDetail";
import greentickmark from "../../signup/assets/greenTickIcon.svg";
import RemitterBankForm from "./remitterBankForm";
import cross from "../../../public/assets/closeIcon.svg";
import CommonButton from "../../CommonButton/CommonButton";

const RemitterBankDetail = ({
  stepToShow,
  setStepsToShow,
  setShortBankDetail,
  shortBankDetail,
  showRemitterBankDetail,
  setShowRemitterBankDetail,
}) => {
  const [accountHolderName, setAccountHolderName] = useState("");
  const [bankName, setBankName] = useState("");
  const [bankCode, setBankCode] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [accountType, setAccountType] = useState("");
  const [IFSC, setIfsc] = useState("");
  const [bankAddress, setBankAddress] = useState("");
  const [loading, setLoading] = useState("");
  const [bankNameError, setBankNameError] = useState("");
  const [accountTypeError, setAccountTypeError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [nextSectionError, setNextSectionError] = useState("");
  const [ifscError, setIfscError] = useState("");
  const [valid, setIsValid] = useState({
    accountHolderName: false,
    bankName: false,
    accountNumber: false,
    accountType: false,
    IFSC: false,
    bankAddress: false,
  });
  const {
    showkyc,
    showkycDetail,
    remitterUserId,
    remitterBankId,
    setRemitterBankId,
    remitterBankSecondFlow,
    setRemitterBankSecondFlow,
    setRemitterBankCardSelection,
    remitterBankCardSelection,
    selectedRemitterBank,
    setSelectedRemitterBank,
    setCompletedRemitter,
    completedRemitter,
    completedStudent,
    showRemitterDetail,
    completedBeneficiary,
    themeColor,
  } = useMyContext("");
  const [filteredList, setFilteredList] = useState([]);
  const [remitterBankLoader, setRemitterBankLoader] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [addnewButton, setAddnewButton] = useState(false);
  const [bankList, setBankList] = useState([]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const getAllBankList = async () => {
      try {
        getBankList().then((res) => {
          if (res && res.data) {
            const list = res.data;
            const filterListWithOnlineBank = list.filter(
              (item) => item.paymentMode === "online",
            );
            const transformedList = filterListWithOnlineBank.map((item) => ({
              label: item.bankName,
              value: item.bankcode,
            }));
            const sortedList = transformedList.sort((a, b) =>
              a.label.localeCompare(b.label),
            );
            setBankList(sortedList);
          }
        });
      } catch (err) {}
    };
    getAllBankList();
  }, []);

  const fetchRemitterBankData = async () => {
    try {
      fetchRemitterBankDetail(remitterUserId).then((response) => {
        setRemitterBankLoader(false);
        if (response && response.data && response.data.length === 0) {
          setRemitterBankCardSelection(false);
          setRemitterBankSecondFlow(false);
          setAddnewButton(true);
        } else {
          setRemitterBankSecondFlow(true);
          setRemitterBankCardSelection(true);
          setAddnewButton(false);
          if (remitterBankId) {
            const selectedCard = response.data.find(
              (item) => item.bankAccountId === remitterBankId,
            );
            if (selectedCard) {
              const temporaryList = response.data.filter(
                (item) => item.bankAccountId !== remitterBankId,
              );
              temporaryList.push(selectedCard);
              setFilteredList(temporaryList);
            }
          } else {
            setFilteredList(response.data);
          }
        }
      });
    } catch (error) {
      setRemitterBankLoader(false);
    }
  };

  useEffect(() => {
    if (selectedRemitterBank) {
      setRemitterBankId(selectedRemitterBank.bankAccountId);
    }
  }, [selectedRemitterBank]);

  function maskAccountNumber(accountNumber) {
    const last4Digits = accountNumber.slice(-4);
    const maskedAccountNumber =
      "X".repeat(accountNumber.length - 4) + last4Digits;
    return maskedAccountNumber;
  }

  const handleChangeOption = (value) => {
    setAccountType(value);
  };

  const handleBankSelectionOption = (value, label) => {
    setBankName(label);
    setBankCode(value);
  };

  useEffect(() => {
    if (remitterBankCardSelection) {
      setShowRemitterBankDetail(false);
      setRemitterBankLoader(true);
      fetchRemitterBankData();
    }
  }, [remitterBankCardSelection]);

  useEffect(() => {
    if (
      !completedRemitter &&
      completedStudent &&
      completedBeneficiary &&
      showRemitterDetail &&
      !showRemitterBankDetail &&
      (showkyc === true ? showkycDetail : true)
    ) {
      setRemitterBankLoader(true);
      fetchRemitterBankData();
    }
  }, [completedStudent, completedBeneficiary]);

  const handleBlur = (e) => {
    if (e.target.name === "IFSC") {
      if (IFSC.length < 11) {
        setIsValid({ ...valid, IFSC: true });
        setIfscError("IFSC Code must be 11 digit long.");
      } else {
        setIfscError("");
        setIsValid({ ...valid, IFSC: false });
      }
    }
  };

  const remitterPersonalDetailApi = () => {
    setLoading(true);
    const body = {
      accountHolderName: accountHolderName,
      bankName: bankName,
      bankCode: bankCode,
      accountNo: accountNumber,
      bankAccountType: accountType,
      ifscCode: IFSC,
      bankAddress: bankAddress,
      pennyDropFlag: true,
    };
    saveBankDetail(body, remitterUserId).then((resp) => {
      try {
        setLoading(false);
        if (resp && resp.status === 200 && resp.data && resp.data.data) {
          setRemitterBankId(
            resp.data.data.bankId || resp.data.data.bankAccountId,
          );
          setRemitterBankCardSelection(false);
          setShortBankDetail({
            accountHolderName: accountHolderName,
            accountMasked: maskAccountNumber(accountNumber),
            bankName: bankName,
          });
          setShowRemitterBankDetail(true);
          setRemitterBankSecondFlow(true);
          setStepsToShow(
            !completedStudent
              ? "StudentStep1"
              : !completedBeneficiary
                ? "BeneficiaryStep1"
                : "",
          );
          setShowModal(false);
          setCompletedRemitter(true);
          setAccountHolderName("");
          setBankName("");
          setAccountNumber("");
          setAccountType("");
          setIfsc("");
          setBankAddress("");
        } else {
          setNextSectionError(
            resp && resp.data
              ? resp.data.message
              : "something went wrong, please try again later.",
          );
        }
      } catch (err) {
        setLoading(false);
        setNextSectionError("something went wrong, please try again later.");
      }
    });
  };

  const checkIfValid = () => {
    setBankNameError("");
    setAccountTypeError("");
    if (accountHolderName === "") {
      setIsValid({ ...valid, accountHolderName: true });
    } else if (bankName === "") {
      setBankNameError("Please select Bank");
    } else if (accountNumber === "") {
      setIsValid({ ...valid, accountNumber: true });
    } else if (accountType === "") {
      setAccountTypeError("Please select Account Type");
    } else if (IFSC === "") {
      setIsValid({ ...valid, IFSC: true });
    } else if (bankAddress === "") {
      setIsValid({ ...valid, IFSC: true });
    } else if (ifscError !== "") {
      setNextSectionError("Please fill all the required field correctly.");
    } else {
      setIsValid({
        accountHolderName: false,
        bankName: false,
        accountNumber: false,
        accountType: false,
        IFSC: false,
        bankAddress: false,
      });
      setNextSectionError("");
      remitterPersonalDetailApi();
    }
  };

  const handleChangeNew = (e) => {
    e.preventDefault();
    setRemitterBankCardSelection(false);
    setStepsToShow("RemitterStep3");
    setShowModal(true);
  };

  const handleChangeBack = (e) => {
    e.preventDefault();
    setRemitterBankCardSelection(true);
    setSelectedRemitterBank(null);
    setShowRemitterBankDetail(false);
    setStepsToShow("");
    setCompletedRemitter(false);
    setShowModal(false);
  };

  const hanldeNextClick = () => {
    setShortBankDetail({
      accountHolderName: selectedRemitterBank.accountHolderName,
      accountMasked: selectedRemitterBank.accountMasked,
      bankName: selectedRemitterBank.bankName,
    });
    setShowRemitterBankDetail(true);
    setRemitterBankCardSelection(false);
    setCompletedRemitter(true);
    setStepsToShow(
      !completedStudent
        ? "StudentStep1"
        : !completedBeneficiary
          ? "BeneficiaryStep1"
          : "",
    );
    // setRemitterBankId(selectedRemitterBank.bankAccountId);
  };

  return (
    <Card className={styles.cardAccount}>
      <Card.Body className={styles.cardBodyAccount}>
        <div className={styles.headingandbutton}>
          <Row className={styles.Title}>Bank Details</Row>
          {remitterBankSecondFlow === true && remitterBankLoader === false && (
            <>
              {remitterBankCardSelection === true ? (
                <div className={styles.buttonaddnew} onClick={handleChangeNew}>
                  <img src={addicon} alt=""></img>
                  Add new
                </div>
              ) : (
                <>
                  <div
                    className={
                      showRemitterBankDetail === false
                        ? styles.buttonback
                        : styles.buttonEdit
                    }
                    onClick={handleChangeBack}
                  >
                    {showRemitterBankDetail &&
                    (stepToShow === "RemitterStep1" ||
                      stepToShow === "RemitterStep2" ||
                      stepToShow === "RemitterStep3")
                      ? "Edit"
                      : stepToShow === "RemitterStep3"
                        ? "Back"
                        : ""}
                  </div>
                </>
              )}
            </>
          )}
        </div>
        {remitterBankLoader ? (
          <Spinner
            animation="border"
            className={styles.spinnerColorOutside}
            style={{ borderColor: themeColor, borderRightColor: "#eaecf0" }}
          />
        ) : (
          <>
            {showRemitterBankDetail === true ? (
              <>
                <Row>
                  <Col md={11} sm={11} xs={10} className={styles.details}>
                    {shortBankDetail.accountHolderName},{" "}
                    {shortBankDetail.accountMasked}, {shortBankDetail.bankName}
                  </Col>
                  <Col md={1} sm={1} xs={2} style={{ position: "relative" }}>
                    <img
                      className={styles.greentick}
                      src={greentickmark}
                      alt=""
                    />
                  </Col>
                </Row>
              </>
            ) : remitterBankSecondFlow === true &&
              remitterBankCardSelection === true ? (
              <>
                <CardDetail
                  cardlist={filteredList}
                  setSelectedValue={setSelectedRemitterBank}
                  selectedValue={selectedRemitterBank}
                  BankType={true}
                  selectedUserid={remitterBankId}
                  type={"Remitter"}
                />
                {remitterBankCardSelection === true &&
                  remitterBankSecondFlow === true && (
                    <Row className="pt-3 mt-3">
                      <CommonButton
                        title="Next"
                        onClick={hanldeNextClick}
                        loading={false}
                        disabled={selectedRemitterBank === null}
                        width={"150px"}
                      />
                    </Row>
                  )}
              </>
            ) : (
              <>
                {stepToShow === "RemitterStep3" ? (
                  <>
                    <div className={styles.showonWeb}>
                      <hr style={{ marginTop: "0px" }} />
                      <RemitterBankForm
                        accountHolderName={accountHolderName}
                        setAccountHolderName={setAccountHolderName}
                        valid={valid}
                        bankName={bankName}
                        setBankName={setBankName}
                        accountNumber={accountNumber}
                        setAccountNumber={setAccountNumber}
                        handleChangeOption={handleChangeOption}
                        accountTypeError={accountTypeError}
                        bankNameError={bankNameError}
                        IFSC={IFSC}
                        ifscError={ifscError}
                        setIfsc={setIfsc}
                        handleBlur={handleBlur}
                        bankAddress={bankAddress}
                        setBankAddress={setBankAddress}
                        nextSectionError={nextSectionError}
                        checkIfValid={checkIfValid}
                        loading={loading}
                        themeColor={themeColor}
                        bankList={bankList}
                        handleBankSelectionOption={handleBankSelectionOption}
                      />
                    </div>
                    {screenWidth < 576 && (
                      <>
                        {addnewButton && (
                          <Row>
                            <Col
                              sm={6}
                              xs={6}
                              className={styles.nodatafoundStyling}
                            >
                              No Data Found
                            </Col>
                            <Col sm={6} xs={6}>
                              <Button
                                style={{
                                  margin: "10px 0px",
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: "14px",
                                }}
                                onClick={() => setShowModal(true)}
                              >
                                Add New
                              </Button>
                            </Col>
                          </Row>
                        )}
                        <Modal
                          show={stepToShow === "RemitterStep3" && showModal}
                        >
                          <div style={{ padding: "20px" }}>
                            <Row>
                              <Col
                                md={9}
                                sm={9}
                                xs={9}
                                className={styles.Title}
                              >
                                Bank Details
                              </Col>
                              <Col
                                md={3}
                                sm={3}
                                xs={3}
                                onClick={
                                  addnewButton
                                    ? () => setShowModal(false)
                                    : handleChangeBack
                                }
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  padding: "10px",
                                }}
                              >
                                <img src={cross} alt="nav-close" />
                              </Col>
                            </Row>
                            <hr style={{ marginTop: "0px" }} />
                            <RemitterBankForm
                              accountHolderName={accountHolderName}
                              setAccountHolderName={setAccountHolderName}
                              valid={valid}
                              bankName={bankName}
                              setBankName={setBankName}
                              accountNumber={accountNumber}
                              setAccountNumber={setAccountNumber}
                              handleChangeOption={handleChangeOption}
                              accountTypeError={accountTypeError}
                              bankNameError={bankNameError}
                              IFSC={IFSC}
                              ifscError={ifscError}
                              setIfsc={setIfsc}
                              handleBlur={handleBlur}
                              bankAddress={bankAddress}
                              setBankAddress={setBankAddress}
                              nextSectionError={nextSectionError}
                              checkIfValid={checkIfValid}
                              loading={loading}
                              themeColor={themeColor}
                              bankList={bankList}
                              handleBankSelectionOption={
                                handleBankSelectionOption
                              }
                            />
                          </div>
                        </Modal>
                      </>
                    )}
                  </>
                ) : (
                  ""
                )}
              </>
            )}
          </>
        )}
      </Card.Body>
    </Card>
  );
};

export default RemitterBankDetail;
